import { useContext, useState } from "react"
import { toolTipText } from "./style"
import { ThemeContext } from "../../App"

export const ToolTipComponent = ({children,text}) => {
    const [theme,setTheme] = useContext(ThemeContext);
    const [visible,setVisible] = useState(false);
    return (
        <>
        <div
        onMouseEnter={() => {setVisible(true)}}
        onMouseLeave={() => {setVisible(false)}}
        >
            {children}
            {visible ? <span style = {toolTipText(theme)}>{text}</span> : null}
        </div>
        </>
    )
}